import type { RestoreJob } from '@repo/api-gw-sdk';

import {
  imageId,
  diskId,
  instanceId,
  queryResults,
  snapshotId,
  volumeId,
  restoredPersistentVolumes,
  restoredResourceName,
  destinationBucket,
  destinationContainer,
  destinationPrefix,
} from '@/components/queryBuilder/outputResourcesProperties';
import {
  backupRegion,
  jobId,
  jobTemporalLink,
  jobResourceName,
  resourceId,
  resourceType,
  restoreAccountId,
  restoreRegion,
  partialRestoreData,
  vault,
  subnet,
  securityGroups,
  instanceProfile,
  encryptionKey,
  instanceType,
  tags,
  restoreJobInitiatorId,
  vmSize,
  networkInterface,
  machineType,
  zone,
  subnetGroup,
  databaseFilter,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const restoreJobItemFields = [
  jobId,
  jobTemporalLink,
  jobResourceName,
  resourceType,
  resourceId,
  restoreJobInitiatorId,
  partialRestoreData,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryFromFields = [
  vault,
  backupRegion,
] as FilterProperty<RestoreJob>[];

export const restoreJobSummaryToFields = [
  restoreAccountId,
  restoreRegion,
  queryResults,
  snapshotId,
  instanceId,
  volumeId,
  imageId,
  diskId,
  restoredPersistentVolumes,
  destinationBucket,
  destinationContainer,
  destinationPrefix,
] as FilterProperty<RestoreJob>[];

export const restoreJobConfigurationFields = [
  databaseFilter,
  restoredResourceName,
  subnet,
  subnetGroup,
  instanceType,
  securityGroups,
  instanceProfile,
  encryptionKey,
  tags,
  vmSize,
  networkInterface,
  zone,
  machineType,
] as FilterProperty<RestoreJob>[];
